/**
 * useGooglePayDefault custom hook.
 * @param {boolean} [isActive=false] - indicate whatever this hook is active
 * @param {Object} config - ApplePay configuration
 */
const useGooglePayDefault = () => {
	return {
		loaded: false,
		loading: false,
		handle: () => null,
		getButton: () => null
	};
};

export default useGooglePayDefault;
